import { render, staticRenderFns } from "./SpaceLeftBar.vue?vue&type=template&id=39440662&scoped=true"
import script from "./SpaceLeftBar.vue?vue&type=script&lang=js"
export * from "./SpaceLeftBar.vue?vue&type=script&lang=js"
import style0 from "./SpaceLeftBar.vue?vue&type=style&index=0&id=39440662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39440662",
  null
  
)

export default component.exports